module.exports = __webpack_public_path__ + "img/cursoExtensao.186642c9.png";